import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;

  > .ui.table td {
    white-space: nowrap;
    max-width: 3rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  > a {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    font-size: 1.3rem;
    padding: 0px 8px;
    border-radius: 8px;
    transition: all ease-in-out 0.35s;
    cursor: pointer;

    &:hover {
      color: #fff;
      background-color: var(--color-primary);
      transform: scale(1.02);
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button,
  a {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }
`;
